export default "__VITE_PUBLIC_ASSET__88c52842__"